export default "__VITE_ASSET__TpF6l$mV__"